import { Mode, Range, PitchClassAlias, PitchClassName } from ".";
import {
  harmonicMinorScalePitchClassMask,
  majorScalePitchClassMask,
  melodicMinorScalePitchClassMask,
  naturalMinorScalePitchClassMask,
  octaveStepMask,
  pentatonicStepMask,
  twoOctaveStepMask,
  pitchClassNames,
  pitchClassAliases,
} from "./constants";

export const getCanonicalScientificPitchNotation = (name: PitchClassName) => {
  let index = pitchClassNames().findIndex((n) => n === name);

  if (index === -1) {
    index = pitchClassAliases().findIndex((n) =>
      (n || []).includes(name as PitchClassAlias)
    );
  }

  return pitchClassNames()[index];
};

export const getScalePattern = (mode: Mode) => {
  switch (mode) {
    case "Harmonic Minor":
      return harmonicMinorScalePitchClassMask();
    case "Major":
      return majorScalePitchClassMask();
    case "Melodic Minor":
      return melodicMinorScalePitchClassMask();
    case "Natural Minor":
      return naturalMinorScalePitchClassMask();
  }
};

export const getStepPattern = (range: Range) => {
  switch (range) {
    case "Octave":
      return octaveStepMask();
    case "Pentatonic":
      return pentatonicStepMask();
    case "Two octave":
      return twoOctaveStepMask();
  }
};

// Type predicates
export function isPitchClassName(pc: string): pc is PitchClassName {
  return (
    pc === 'A'  ||
    pc === 'A#' ||
    pc === 'B'  ||
    pc === 'C'  ||
    pc === 'C#' ||
    pc === 'D'  ||
    pc === 'D#' ||
    pc === 'E'  ||
    pc === 'F'  ||
    pc === 'F#' ||
    pc === 'G'  ||
    pc === 'G#' ||
    pc === 'B#' ||
    pc === 'Db' ||
    pc === 'Eb' ||
    pc === 'Fb' ||
    pc === 'E#' ||
    pc === 'Gb' ||
    pc === 'Ab' ||
    pc === 'Bb' ||
    pc === 'Cb'
  );
}
